import React, { forwardRef, useState, useEffect, useImperativeHandle } from 'react'
import { StatusCellComponent } from '../../../../masters/studentFinancials/paymentGatewaysConfiguration/common';
import { getFormatedDate } from '../../../../unAssigned/concessionApproval/common';
import NoRowOverlay from '../../../../masters/holidayMaster/NoRowOverlay';
import { gridComponents, gridStyles } from '../../../../edpOps/issuanceIDcard/printIdCardAndMapRfid/constant';
import { AGridColDef } from '../../../../common/data-grid/ADataGridColDef';
import ADataGrid from '../../../../common/data-grid/ADataGrid';
import { saveOrDeleteMsg } from 'views/pages/manage/edpOps/stockManagement/mastersAndMapping/sapProfitCostCentreMapping/constant';
import { failureToast } from 'views/pages/manage/common/utils/methods/toasterFunctions/function';
import { isObjEmpty } from 'views/pages/manage/common/utils/methods/commonMethods/utilityMethod';
import { GridRowModes } from '@mui/x-data-grid';
import { ActionsCellComponent } from '../../../../masters/studentFinancials/paymentGatewaysConfiguration/common';
import { getFormattedDate } from 'views/pages/manage/edpOps/constant/batch-search';
import AInput from 'views/pages/manage/common/formFeilds/customInput/AInput';
import { editCellContainerStyle } from 'views/pages/manage/edpOps/stockManagement/mastersAndMapping/onBoardingMaterialIdSetup/constant';
import AAutoComplete from 'views/pages/manage/common/form-fields-mui/AAutoComplete';
import { newRow } from './constant';
import { generateRandomId } from 'views/pages/manage/common/utils/methods/commonMethods/utilityMethod';
import ALoader from 'views/pages/manage/common/a-loader';
import { ReactComponent as CancelIcon } from 'assets/img/svg/RedCancel.svg';
import moment from 'moment';
import { Tooltip } from '@mui/material';


const ListComponent = ({
    businessAreaDropdown = [],
    rows = [],
    createUpdateHandler,
    loading,
    currentPage,
    totalRecords,
    pageChangeHandler,
    dropdowns,
    setDropdowns
}, ref) => {

    const [rowModesModel, setRowModesModel] = useState({});
    const [rowData, setRowData] = useState(rows);
    const [rowForm, setRowForm] = useState({});


    const rowFormHandler = (value, key) =>
        setRowForm((prev) => ({ ...prev, [key]: value }));

    useEffect(() => {
        setRowData(rows);
    }, [rows]);


    const startEditing = (id, form) => {
        setRowModesModel((oldModel) => ({
            [id]: { mode: GridRowModes.Edit },
        }));
        setRowForm(form);
    };

    const stopEditing = () => {
        console.log('Hello')
        const currForm = { ...rowForm };
        setRowModesModel((oldModel) => ({
            [currForm?.id]: { mode: GridRowModes.View, ignoreModifications: true },
        }));
        setRowForm({});
    };

    const handleEditClick = (params) => {
        if (!isObjEmpty(rowForm)) {
            failureToast(saveOrDeleteMsg);
        } else {
            startEditing(params?.id, params?.row);
        }
    };

    const handleCancelClick = async (params) => {
        if (params?.row?.isNew) {
            setRowData(rows);
            setRowForm({});
        } else {
            stopEditing(params?.id);
        }
    };

    const handleSaveClick = async (params) => {
        createUpdateHandler(rowForm);
    };

    const addNewRow = async () => {
        if (!isObjEmpty(rowForm)) {
            failureToast(saveOrDeleteMsg);
        } else {
            let randomId = generateRandomId();
            let emptyRow = {
                ...newRow,
                isNew: true,
                id: randomId,
            };
            startEditing(randomId, emptyRow);
            setRowData((prev) => [emptyRow, ...prev]);
        }
    };

    useImperativeHandle(ref, () => ({
        addNewRow: addNewRow,
        startEditing: startEditing,
        stopEditing: stopEditing,
    }));

    const columns = [
        new AGridColDef('gatewayType', 'Payment Gateway', false)
            .setMinWidth(110)
            .setFlex(0.8)
            .editable(true)
            .setValueGetter(params => params?.value?.label)
            .renderEditCellComponent(params => (
                <div style={editCellContainerStyle}>
                    <AAutoComplete
                        currentValue={rowForm?.gatewayType}
                        handleChange={value => {
                            rowFormHandler(value, 'gatewayType');
                        }}
                        items={dropdowns?.gatewayType}
                        isMulti={false}
                        //style={selectStyles}
                        placeholder={'Select'}
                        autoFocus={params?.hasFocus}
                    />
                </div>
            )),

        new AGridColDef('merchantId', 'Merchant Id', false)
            .setMinWidth(110)
            .setFlex(0.5)
            .editable(true)
            .setValueGetter(params => params?.value)
            .renderEditCellComponent(params => (
                <div style={editCellContainerStyle}>
                    <AInput
                        // key={`${index}-${col?.colKey}`}
                        type="text"
                        value={rowForm?.merchantId}
                        handler={(value) => {
                            rowFormHandler(value, 'merchantId');
                        }}
                        placeholder="Enter"
                    //style={inputStyle}
                    // maxLength={''}
                    />
                </div>
            )),
        new AGridColDef('paymentKey', 'key', false)
            .setMinWidth(80)
            .setFlex(0.8)
            .editable(true)
            .setValueGetter(params => params?.value)
            .renderEditCellComponent(params => (
                <div style={editCellContainerStyle}>
                    <AInput
                        //key={`${index}-${col?.colKey}`} // Ensure unique key
                        type="text"
                        value={rowForm?.paymentKey}
                        handler={(value) => {
                            rowFormHandler(value, 'paymentKey');
                        }}
                        placeholder="Enter"
                    //style={inputStyle}
                    //maxLength={col?.maxLength}
                    />
                </div>
            )),

        new AGridColDef('salt', 'Salt', false)
            .setMinWidth(110)
            .setFlex(0.8)
            .editable(true)
            .setValueGetter(params => params?.value)
            .renderEditCellComponent(params => (
                <div style={editCellContainerStyle}>
                    <AInput
                        type="text"
                        value={rowForm?.salt} // Dynamically access value
                        handler={(value) => {
                            rowFormHandler(value, 'salt');
                        }}
                        placeholder="Enter"
                    // style={inputStyle}
                    // maxLength={col?.maxLength}
                    />
                </div>
            )),
        new AGridColDef('updatedOn', 'Last Updated On', false)
            .setMinWidth(120)
            .setFlex(1)
            .editable(false)
            .renderCellComponent((params) =>
                params?.value ? (
                    <Tooltip title={`${moment(params?.value).format('hh:mm A')}, ${moment(params?.value).format('DD MMM YYYY')} by ${params?.row?.updatedBy}`}>
                        <div className="ellipsis-text-container">
                            {`${moment(params?.value).format('hh:mm A')}, ${moment(params?.value).format('DD MMM YYYY')} by ${params?.row?.updatedBy}`}
                        </div>
                    </Tooltip>
                ) : (
                    <div className="m-auto">-</div>
                )
            )
        ,
        new AGridColDef('status', 'Status', false)
            .setMinWidth(120)
            .setFlex(1)
            .editable(true)
            .renderCellComponent((params) => {
                console.log('params', params?.value)
                return <StatusCellComponent value={params.value} showText />
            })
            .renderEditCellComponent((params) => (
                <StatusCellComponent
                    value={rowForm?.status}
                    handleChange={(val) => {
                        rowFormHandler(val, "status");
                        // If status is set to INACTIVE, automatically set primary to false
                        if (val === 'INACTIVE') {
                            rowFormHandler(false, "isPrimary");
                        }
                    }}
                    showText
                />
            )),
        new AGridColDef('isPrimary', 'Primary', false)
            .setMinWidth(120)
            .setFlex(1)
            .editable(true)
            .renderCellComponent((params) => {
                return <StatusCellComponent value={params.value ? 'ACTIVE' : 'INACTIVE'} showText />
            })
            .renderEditCellComponent((params) => (
                <StatusCellComponent
                    value={rowForm?.isPrimary ? 'ACTIVE' : 'INACTIVE'}
                    handleChange={(val) => {
                        const isPrimary = val === 'ACTIVE' ? true : false;
                        rowFormHandler(isPrimary, "isPrimary");
                        // If primary is set to true, automatically set status to ACTIVE
                        if (isPrimary && rowForm?.status === 'INACTIVE') {
                            rowFormHandler('ACTIVE', "status");
                        }
                    }}
                    showText
                />
            ))

        ,
        new AGridColDef('actions', 'Action', false)
            .setMinWidth(100)
            .setFlex(1)
            .editable(true)
            // .pinColumnLast(true)
            .columnAlign('right')
            .renderCellComponent(params =>
                <ActionsCellComponent
                    mode={'view'}
                    handleEditClick={handleEditClick}
                    icon={true}
                    cancelIcon={true}
                    //deleteIcon={true}
                    params={params}
                    customEditIcon
                />
            )
            .renderEditCellComponent(params => (
                <ActionsCellComponent
                    mode={'edit'}
                    handleSaveClick={handleSaveClick}
                    // handleCancelClick={handleCancelClick}
                    icon={true}
                    cancelIcon={<CancelIcon
                        className="mx-2 cursor"
                        onClick={() => handleCancelClick(params)}
                    />}
                    //deleteIcon={true}
                    isSaveDisabled={!(rowForm?.gatewayType && rowForm?.merchantId && rowForm?.paymentKey && rowForm?.salt && rowForm?.status)}
                    params={params}
                />
            )),

    ]

    return (
        <>
            {loading && <ALoader position='fixed' />}
            <ADataGrid
                removeWrapperContainer
                rowModesModel={rowModesModel}
                rows={rowData || []}
                columns={columns}
                serverPagination={false}
                rowId={(row) => (row?.id)}
                rowHeight={50}
                loading={false}
                rowCount={totalRecords}
                nextButtonHandler={pageChangeHandler}
                currentPage={currentPage}
                hidePagination
                components={{
                    ...gridComponents,
                    NoRowsOverlay: () => (
                        <NoRowOverlay message={loading ? "Loading..." : null} />
                    ),
                }}
                sx={gridStyles}
                autoHeight
            // pinLastColumn
            />
        </>
    );
}

export default forwardRef(ListComponent);